import type { UnitSystem } from "../types/preferences";
import type { CalculationMode, WeldParameterInputs } from "../calculators/weldParameter/types";

type InputKey = keyof WeldParameterInputs;

export type DisplayMetric = InputKey | CalculationMode | "area" | "volumeRate" | "factor" | "angle";

export function unitFor(metric: DisplayMetric, unitSystem: UnitSystem) {
  if (metric === "factor") {
    return "";
  }

  if (metric === "angle") {
    return "°";
  }

  if (unitSystem === "metric") {
    if (metric === "wireFeed") return "m/min";
    if (metric === "travelSpeed") return "cm/min";
    if (metric === "area") return "mm²";
    if (metric === "volumeRate") return "mm³/min";
    return "mm";
  }

  if (metric === "wireFeed" || metric === "travelSpeed") return "in/min";
  if (metric === "area") return "in²";
  if (metric === "volumeRate") return "in³/min";
  return "in";
}

export function decimalsFor(metric: DisplayMetric, unitSystem: UnitSystem) {
  if (metric === "factor") return 4;
  if (metric === "angle") return 0;
  if (metric === "wireFeed") return unitSystem === "metric" ? 2 : 1;
  if (metric === "travelSpeed") return 1;
  if (metric === "area") return unitSystem === "metric" ? 2 : 4;
  if (metric === "volumeRate") return unitSystem === "metric" ? 0 : 2;
  if (unitSystem === "imperial") return 3;
  return 2;
}

export function compactDecimalsFor(metric: DisplayMetric, unitSystem: UnitSystem, value: number) {
  if (metric === "factor") return 4;
  if (metric === "area") {
    return unitSystem === "metric" ? 2 : value < 0.01 ? 4 : 3;
  }
  if (metric === "volumeRate") {
    return unitSystem === "metric" ? 1 : 2;
  }
  return decimalsFor(metric, unitSystem);
}

export function toDisplayValue(
  key: InputKey | CalculationMode | "area" | "volumeRate" | "factor" | "angle",
  metricValue: number,
  unitSystem: UnitSystem
) {
  if (unitSystem === "metric") return metricValue;

  if (key === "wireFeed") return metricValue / 0.0254;
  if (key === "travelSpeed") return metricValue / 2.54;
  if (key === "area") return metricValue / 645.16;
  if (key === "volumeRate") return metricValue / 16387.064;
  if (key === "angle") return metricValue;
  return metricValue / 25.4;
}

export function fromDisplayValue(key: InputKey | "angle", displayValue: number, unitSystem: UnitSystem) {
  if (unitSystem === "metric") return displayValue;

  if (key === "angle") return displayValue;
  if (key === "wireFeed") return displayValue * 0.0254;
  if (key === "travelSpeed") return displayValue * 2.54;
  return displayValue * 25.4;
}
